import React from 'react'

export default function ErrorPage() {
  return (
    <div>
      <img src="https://www.myphukettravel.com/assets/front-end/images/404.gif" style={{margin:"auto", width:"73%" , height:"510px"}}/>
    </div>
  )
}
